import React from "react";
import ReactDOM from "react-dom";
import Popup from "./Popup";
import {
  INPUT_TYPE,
  INPUT_VIEW_DIRECTION,
  DKCheckMark,
  DKLabel,
  DKButton,
  isEmpty,
  showLoader,
  removeLoader,
  DKIcons,
  DKIcon,
  getDataTypeIcon,
  TOAST_TYPE,
  showToast,
} from "deskera-ui-library";
import Table from "../../services/table";
import { TableManger } from "../../managers/TableManger";
import { IColumn } from "../../model/Table";
import InitialApiManager from "../../managers/InitialApiManager";
import TableDataParser from "../../Helper/TableDataParser";
import ControlledInput from "../common/ControlledInput";
import { CHAR_CODES } from "../../constants/Constant";

export interface IAddColumnPopupProps {
  tableName: string;
  popupId?: string;
  onSave?: () => void;
  onClose?: () => void;
}
export interface IAddColumnPopupState {
  formData: any;
  optionFieldText: string;
  submitted: boolean;
}
class AddColumnPopup extends React.Component<
  IAddColumnPopupProps,
  IAddColumnPopupState
> {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: "",
        type: INPUT_TYPE.TEXT,
        required: false,
        options: [],
      },
      optionFieldText: "",
      submitted: false,
    };
  }
  onOptionChange = (value) => {
    this.setState({
      optionFieldText: value,
    });
  };
  onOptionKeyPress = (e) => {
    if (e.charCode === CHAR_CODES.ENTER) { // on enter pressed
      this.onOptionAdd();
    }
  }
  onOptionAdd = () => {
    if (isEmpty(this.state.optionFieldText)) return;
    let options = [...this.state.formData.options];
    let { optionFieldText } = this.state;
    options.push({
      id: this.state.formData.options.length,
      name: optionFieldText,
      color: `data-grid-badge-color-${Math.round(Math.random() * 8) + 1}`,
    });
    this.onFormValueChange("options", options);
    this.setState({
      optionFieldText: "",
    });
  };
  onFormValueChange = (key, value) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [key]: value,
      },
    });
  };
  onSave = () => {
    this.setState({
      submitted: true,
    });
    if (this.state.formData.name.trim().length === 0) return;
    if (
      this.state.formData.required &&
      (this.state.formData.type === INPUT_TYPE.SELECT ||
        this.state.formData.type === INPUT_TYPE.SELECT) &&
      this.state.formData.options.length === 0
    ) {
      showToast("Please add at least one option", TOAST_TYPE.FAILURE);
      return;
    }
    showLoader(`Custom field is being added...`);
    let column: IColumn = TableDataParser.getColumnToAdd({
      ...this.state.formData,
    });
    Table.addColumn(column, TableManger.getTableId(this.props.tableName))
      .then((data) => {
        InitialApiManager.getTableData().then((data) => {
          if (this.props.onSave) this.props.onSave();
        });
        this.removePopUp();
      })
      .catch((err) => {})
      .finally(() => removeLoader());
  };
  onCancel = () => {
    this.removePopUp();
  };
  removePopUp = () => {
    if (this.props.popupId)
      ReactDOM.unmountComponentAtNode(
        document.getElementById(this.props.popupId)
      );
    document.getElementById(this.props.popupId)?.remove();
    if (this.props.onClose) this.props.onClose();
  };
  render() {
    return (
      <Popup>
        {this.getHeader()}
        {this.getForm()}
      </Popup>
    );
  }
  getHeader = () => {
    return (
      <div className="row align-items-center justify-content-between parent-width">
        <div className="row fs-xl fw-h">New Field</div>
        <div className="row-reverse action-btn-wrapper">
          <DKButton
            className="border-m ml-r bg-app text-white"
            title="Save"
            onClick={this.onSave}
          />
          <DKButton
            className="border-m bg-white"
            title="Cancel"
            onClick={this.onCancel}
          />
        </div>
      </div>
    );
  };
  onOptionRemove = (index) => {
    let options = [...this.state.formData.options];
    options.splice(index, 1);
    this.onFormValueChange("options", options);
  };
  getForm = () => {
    return (
      <>
        <div className="row mt-l">
          <ControlledInput
            required
            invalid={
              this.state.submitted &&
              this.state.formData.name.trim().length === 0
            }
            name="Name"
            type={INPUT_TYPE.TEXT}
            value={this.state.formData.name}
            direction={INPUT_VIEW_DIRECTION.VERTICAL}
            onChange={(e) => this.onFormValueChange("name", e.target.value)}
          />
        </div>
        <div className="row mt-l">{this.getFieldTypeSelection()}</div>
        {(this.state.formData.type === INPUT_TYPE.SELECT ||
          this.state.formData.type === INPUT_TYPE.MULTI_SELECT) && (
          <div className="row mt-l">{this.getAddOptionField()}</div>
        )}
        {this.state.formData.options.length > 0 && this.getOptionList()}
        <div className={`row align-items-center`}>
          <DKCheckMark
            className="mt-l mb-m"
            isSelected={this.state.formData.required}
            onClick={(value) =>
              this.onFormValueChange("required", !this.state.formData.required)
            }
          />
          <DKLabel text="Is mandatory?" className="ml-s mt-s" />
        </div>
      </>
    );
  };
  getFieldTypeSelection = () => {
    const INPUT_TYPE_ARR = [
      INPUT_TYPE.TEXT,
      INPUT_TYPE.NUMBER,
      INPUT_TYPE.EMAIL,
      INPUT_TYPE.DATE,
      INPUT_TYPE.SELECT,
      INPUT_TYPE.MULTI_SELECT,
    ];
    return (
      <div className="parent-width border">
        <DKLabel text={"Select field type"} />
        <div className={`column-type-wrapper`}>
          {INPUT_TYPE_ARR.map((item) => {
            return (
              <div
                className={`p-s bg-white mr-r mt-r border-radius-s border-m d-flex align-items-center cursor-hand
                            ${
                              this.state.formData.type === item
                                ? "border-blue text-blue fw-m"
                                : ""
                            }`}
                onClick={() => {
                  this.onFormValueChange("type", item);
                  setTimeout(() => this.onFormValueChange("options", []), 0);
                }}
              >
                <DKIcon
                  src={getDataTypeIcon(item)}
                  className="ic-xs cursor-hand"
                />
                <span className="ml-s">{item}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  getAddOptionField = () => {
    return (
      <div className="row align-items-end" style={{ width: "80%" }}>
        <ControlledInput
          required
          name="Options"
          type={INPUT_TYPE.TEXT}
          value={this.state.optionFieldText}
          direction={INPUT_VIEW_DIRECTION.VERTICAL}
          onChange={(e) => this.onOptionChange(e.target.value)}
          onKeyPress={(e) => this.onOptionKeyPress(e)}
        />
        <DKButton
          title="Add"
          style={{ marginBottom: "3px" }}
          className="border-m ml-r bg-app text-white"
          onClick={this.onOptionAdd}
        />
      </div>
    );
  };
  getOptionList = () => {
    return (
      <div className="row pt-s flex-wrap">
        {this.state.formData.options.map((option, index) => {
          return (
            <div
              className={`p-s border-radius-s mr-s mt-s d-flex align-items-center ${option.color}`}
              id={`${option.id}`}
            >
              <span>{option.name}</span>
              <DKIcon
                src={DKIcons.ic_close}
                className="ic-s ml-s cursor-hand"
                onClick={() => this.onOptionRemove(index)}
              />
            </div>
          );
        })}
      </div>
    );
  };
}
export const showAddColumnPopup = (
  config: { tableName: string },
  onSave?: () => void,
  onClose?: () => void
) => {
  const id = `add-new-col-popup-${new Date().getTime()}`;
  let div = document.createElement("div");
  div.className = "app-font";
  div.setAttribute("id", id);
  ReactDOM.render(
    <AddColumnPopup
      popupId={id}
      tableName={config.tableName}
      onSave={onSave}
      onClose={onClose}
    />,
    document.body.appendChild(div)
  );
};
export default AddColumnPopup;
